import log from "loglevel";
import OnReloadFullScreenLoader from "Components/OnReloadFullScreenLoader";
import React from "react";
import { Button, Alert, Container, Row, Col, Image } from "react-bootstrap";

class ErrorBoundary extends React.Component {
  state = {
    hasError: false,
    error: null,
    errorInfo: null,
    showDetails: false
  };

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    log.log("---- Error Boundary ----");
    log.error(error);
    log.error(errorInfo);
    log.log("---- -------------- ----");

    // Store error details in state
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }

  toggleErrorDetails = () => {
    this.setState(prevState => ({
      showDetails: !prevState.showDetails
    }));
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: "100vh",
            minHeight: "100svh",
            background: "rgb(223 240 255)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: "2rem"
          }}
        >
          <div>
            <Image
              src='/images/default_image.png'
              alt='Bodhitree Logo'
            />
          </div>
          <Container>
            <Row className="justify-content-center">
              <Col md={10} lg={8} xl={6}>
                <div
                  className="error-card p-4 rounded-lg shadow"
                  style={{
                    backgroundColor: "white",
                    borderRadius: "12px",
                    border: "1px solid rgba(0,0,0,0.08)"
                  }}
                >
                  <div className="text-center mb-4">
                    <div className="mb-4" style={{ fontSize: "60px" }}>
                      😕
                    </div>
                    <h2 className="fw-bold mb-2" style={{ color: "#3a3a3a" }}>Oops! Something went wrong</h2>
                    <p className="text-muted mb-4" style={{ fontSize: "16px" }}>
                      We're sorry for the inconvenience. The application encountered an unexpected error.
                    </p>
                  </div>

                  <OnReloadFullScreenLoader />

                  <div className="d-flex justify-content-center mb-4">
                    <Button
                      variant="link"
                      onClick={this.toggleErrorDetails}
                      className="text-decoration-none"
                      style={{ fontSize: "14px" }}
                    >
                      {this.state.showDetails ? "Hide" : "Show"} Technical Details
                    </Button>
                  </div>

                  {this.state.showDetails && this.state.error && (
                    <Alert
                      variant="light"
                      className="text-start mb-4 overflow-auto"
                      style={{
                        maxHeight: "200px",
                        fontSize: "14px",
                        backgroundColor: "#f8f9fa",
                        border: "1px solid #e9ecef",
                        borderRadius: "8px"
                      }}
                    >
                      <p className="fw-bold mb-1">Error:</p>
                      <p className="mb-2" style={{ color: "#dc3545" }}>{this.state.error.toString()}</p>

                      {this.state.errorInfo && (
                        <>
                          <p className="fw-bold mb-1">Component Stack:</p>
                          <pre className="mb-0" style={{ fontSize: "12px", color: "#6c757d" }}>
                            {this.state.errorInfo.componentStack}
                          </pre>
                        </>
                      )}
                    </Alert>
                  )}

                  <div className="d-flex gap-3 justify-content-center">
                    <Button
                      variant="primary"
                      onClick={() => window.location.reload()}
                      className="px-4 py-2"
                      style={{
                        borderRadius: "8px",
                        fontWeight: "500",
                        // background: "linear-gradient(to right, #4776E6,rgb(12, 162, 255))",
                        border: "none",
                        // boxShadow: "0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08)"
                      }}
                    >
                      <i className="bi bi-arrow-clockwise me-2"></i>
                      Reload Page
                    </Button>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;